import ls from 'localstorage-slim';
import axios from 'axios';

export async function refreshToken() {
  const subDomain = ls.get('subDomain');
  const refresh = ls.get('refresh');
  try {
    let response = await axios.post(
      `${subDomain}${process.env.REACT_APP_DJANGO_BASEURL}/token/refresh/`,
      {
        refresh,
      }
    );

    ls.set('access', response.data['access'], { ttl: 3600 });
    ls.set('refresh', response.data['refresh'], { ttl: 3600 * 24 });
  } catch (error) {
    if (error.response) {
      // Request made but the server responded with an error
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // Request made but no response is received from the server.
      console.log(error.request);
    } else {
      // Error occured while setting up the request
      console.log('Error', error.message);
    }
  }
}

export async function getETAToken() {
  const subDomain = ls.get('subDomain');
  const taxpayer = ls.get('taxpayer_id');
  try {
    let response = await axios.get(
      `${subDomain}${process.env.REACT_APP_DJANGO_BASEURL}/erp/get_eta_token`,
      {
        params: {
          taxpayer,
        },
      }
    );

    ls.set('ETAToken', response.data.access_token, { ttl: 600 });
  } catch (error) {
    if (error.response) {
      // Request made but the server responded with an error
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // Request made but no response is received from the server.
      console.log(error.request);
    } else {
      // Error occured while setting up the request
      console.log('Error', error.message);
    }
  }
}

export async function logout() {
  try {
    let refresh = ls.get('refresh');
    let subDomain = ls.get('subDomain');
    let response = await axios.post(
      `${subDomain}${process.env.REACT_APP_DJANGO_BASEURL}/token/blacklist/`,
      { refresh },
      {
        headers: { Authorization: `Bearer ${ls.get('access')}` },
      }
    );
    ls.clear();
    window.location.reload();
  } catch (error) {
    if (error.response) {
      // Request made but the server responded with an error
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // Request made but no response is received from the server.
      console.log(error.request);
    } else {
      // Error occured while setting up the request
      console.log('Error', error.message);
    }
  }
}

export async function updateUserLastLogin() {
  const subDomain = ls.get('subDomain');
  const taxpayer = ls.get('taxpayer_id');
  try {
    let response = await axios.get(
      `${subDomain}${process.env.REACT_APP_DJANGO_BASEURL}/auth/update_user_last_login`,
      {
        params: {
          taxpayer,
        },
      }
    );
  } catch (error) {
    if (error.response) {
      // Request made but the server responded with an error
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // Request made but no response is received from the server.
      console.log(error.request);
    } else {
      // Error occured while setting up the request
      console.log('Error', error.message);
    }
  }
}
